import { render, staticRenderFns } from "./HandleGeneralSummary.vue?vue&type=template&id=70838a91&"
import script from "./HandleGeneralSummary.vue?vue&type=script&lang=js&"
export * from "./HandleGeneralSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports